import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Label
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardDoctorFeeReportUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardDoctorFeeReportUX-div-0"
        style={{width: "100%",height:"100%",padding:"10px"}}>
        <div
          id="CardDoctorFeeReportUX-div-5"
          style={{display: "flex", marginBottom: "0.75rem"}}>
          
          <Button
            color={props.activeTab === "description"? "blue":""}
            id="CardDoctorFeeReportUX-Button-6"
            name="description"
            onClick={props.onChangeTab}
            size="small"
            style={{marginRight: "0.75rem"}}>
            รายละเอียดค่าตอบแทน
          </Button>
          <Button
            color={props.activeTab === "overview"? "blue":""}
            id="CardDoctorFeeReportUX-Button-7"
            name="overview"
            onClick={props.onChangeTab}
            size="small"
            style={{marginRight: "0.75rem"}}>
            ภาพรวมค่าตอบแทนแพทย์
          </Button>
          <Button
            id="CardDoctorFeeReportUX-Button-175"
            name="doctorFeeByPaymentReport"
            onClick={() => props.onHandleSelectedMenu("รายงานค่าตอบแทนแพทย์ตามวันที่รับชำระ")}
            size="small"
            style={{marginRight: "0.75rem"}}>
            รายงานค่าตอบแทนแพทย์ตามวันที่รับชำระ
          </Button>
        </div>
        <div
          className="ui form"
          id="CardDoctorFeeReportUX-div-1">
          
          <div
            id="CardDoctorFeeReportUX-div-4"
            style={{fontSize: "1.15rem", fontWeight: "bold", padding: "2.5px 0"}}>
            {props.table?.title || "-"}
          </div>
        </div>
        <div
          className="ui divider"
          id="CardDoctorFeeReportUX-div-3"
          style={{marginTop: "0.5rem"}}>
          
        </div>
        <div
          className="ui form small"
          id="CardDoctorFeeReportUX-div-56">
          
          <FormGroup
            id="CardDoctorFeeReportUX-FormGroup-57"
            inline={true}>
            <FormField
              className="required"
              id="CardDoctorFeeReportUX-FormField-58"
              inline={true}>
              <label
                id="CardDoctorFeeReportUX-label-66"
                style={{minWidth: "max-content"}}>
                วันที่รักษา
              </label>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-59"
              inline={true}
              style={{minWidth: "10rem"}}
              width={1}>
              <div
                id="CardDoctorFeeReportUX-div-72"
                style={{width: "100%"}}>
                
                <DateTextBox
                  id="CardDoctorFeeReportUX-DateTextBox-74"
                  onChange={(value: string)=>props.onChangeFilter?.(null,{name:"startDate", value})}
                  value={props.filter?.startDate || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-60"
              inline={true}>
              <label
                id="CardDoctorFeeReportUX-label-67">
                ถึง
              </label>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-61"
              inline={true}
              style={{minWidth: "10rem"}}
              width={1}>
              <div
                id="CardDoctorFeeReportUX-div-73"
                style={{width: "100%"}}>
                
                <DateTextBox
                  id="CardDoctorFeeReportUX-DateTextBox-75"
                  onChange={(value: string)=>props.onChangeFilter?.(null,{name:"endDate", value})}
                  value={props.filter?.endDate || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-62"
              inline={true}
              width={3}>
              <label
                id="CardDoctorFeeReportUX-label-68"
                style={{minWidth: "max-content"}}>
                คลินิกที่ออกตรวจ
              </label>
              <Dropdown
                className="inline-label"
                fluid={true}
                id="CardDoctorFeeReportUX-Dropdown-76"
                name="division"
                onChange={props.onChangeFilter}
                options={props.divisionOptions|| []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.division || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-63"
              inline={true}
              width={2}>
              <label
                id="CardDoctorFeeReportUX-label-69">
                คาบ
              </label>
              <Dropdown
                className="inline-label"
                fluid={true}
                id="CardDoctorFeeReportUX-Dropdown-77"
                name="period"
                onChange={props.onChangeFilter}
                options={props.periodOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.period || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-64"
              inline={true}
              width={3}>
              <label
                id="CardDoctorFeeReportUX-label-70"
                style={{minWidth: "max-content"}}>
                เวลาออกตรวจ
              </label>
              <Dropdown
                className="inline-label"
                fluid={true}
                id="CardDoctorFeeReportUX-Dropdown-78"
                name="workingType"
                onChange={props.onChangeFilter}
                options={props.workingTypeOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.workingType|| ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-65"
              inline={true}
              style={{display: props.activeTab === "description"? "": "none"}}
              width={4}>
              <label
                id="CardDoctorFeeReportUX-label-71"
                style={{minWidth: "max-content"}}>
                สถานะการชำระเงินของผู้ป่วย
              </label>
              <Dropdown
                className="inline-label"
                fluid={true}
                id="CardDoctorFeeReportUX-Dropdown-79"
                name="status"
                onChange={props.onChangeFilter}
                options={props.paymentStatusOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.status|| ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-135"
              inline={true}
              style={{display: props.activeTab === "overview"? "": "none"}}
              width={4}>
              <label
                id="CardDoctorFeeReportUX-label-136"
                style={{minWidth: "max-content"}}>
                สถาะส่งเบิก
              </label>
              <Dropdown
                className="inline-label"
                fluid={true}
                id="CardDoctorFeeReportUX-Dropdown-137"
                name="filter.status"
                onChange={props.onChangeFilter}
                options={props.sentClaimStatusOptions||[]}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.status|| ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-80"
              inline={true}>
              <div
                id="CardDoctorFeeReportUX-div-81">
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardDoctorFeeReportUX-div-23">
          
          <Table
            data={props.data}
            getTdProps={props.onGetTdProps}
            getTheadThProps={props.onGetTheadThProps}
            headers={props.table?.headers}
            id="CardDoctorFeeReportUX-Table-24"
            keys={props.table?.keys}
            minRows={6}
            showPagination={false}
            style={{height: props.table?.height || ""}}
            widths={props.table?.widths}>
          </Table>
        </div>
        <div
          id="CardDoctorFeeReportUX-div-82"
          style={{margin:  "1rem 0 -1rem 0.5rem",display: props.activeTab === "description"? "": "none", fontSize: "0.85rem"}}>
          
          <div
            id="CardDoctorFeeReportUX-div-83">
            หมายเหตุ ส่วนแบ่ง (%) ยังไม่ได้ถูกหักค่า LAB (ถ้ามี)
          </div>
          <div
            id="CardDoctorFeeReportUX-div-84">
            C- ได้รับเป็นเงิน P-ได้รับเป็นแต้มสะสม
          </div>
        </div>
        <div
          className="ui form"
          id="CardDoctorFeeReportUX-div-85"
          style={{paddingLeft: "5rem", marginTop: "0.5rem"}}>
          
          <FormGroup
            id="CardDoctorFeeReportUX-FormGroup-86"
            inline={true}
            style={{marginBottom: "-0.25rem"}}>
            <FormField
              id="CardDoctorFeeReportUX-FormField-89"
              inline={true}
              width={9}>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-90"
              inline={true}
              width={8}>
              <div
                className="ui form"
                id="CardDoctorFeeReportUX-div-97"
                style={{width: "100%"}}>
                
                <FormGroup
                  id="CardDoctorFeeReportUX-FormGroup-100"
                  inline={true}
                  widths={16}>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-101"
                    inline={true}
                    width={9}>
                    <label
                      id="CardDoctorFeeReportUX-label-111"
                      style={{minWidth: "12rem", maxWidth: "12rem",fontSize: "0.85rem"}}>
                      รายรับทั้งหมด
                    </label>
                    <Label
                      id="CardDoctorFeeReportUX-Label-112"
                      size="large"
                      style={{width: "100%", textAlign: "right"}}>
                      {props.summary?.total_revenue_price || "\u00a0"}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-102"
                    inline={true}
                    width={8}>
                  </FormField>
                </FormGroup>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDoctorFeeReportUX-FormGroup-87"
            inline={true}
            style={{marginBottom: "-0.25rem"}}>
            <FormField
              id="CardDoctorFeeReportUX-FormField-91"
              inline={true}
              width={9}>
              <div
                className="ui form"
                id="CardDoctorFeeReportUX-div-117"
                style={{width: "100%"}}>
                
                <FormGroup
                  id="CardDoctorFeeReportUX-FormGroup-119"
                  inline={true}
                  widths={16}>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-124"
                    inline={true}
                    style={{display: props.activeTab === "description"? "": "none"}}
                    width={12}>
                    <label
                      id="CardDoctorFeeReportUX-label-127"
                      style={{minWidth: "max-content",fontSize: "0.85rem"}}>
                      ยอดรวมส่งเบิก
                    </label>
                    <Label
                      id="CardDoctorFeeReportUX-Label-134"
                      size="large"
                      style={{width: "100%", textAlign: "right"}}>
                      {props.summary?.total_send_claim|| "\u00a0"}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-138"
                    inline={true}
                    style={{display: props.activeTab === "overview"? "": "none"}}
                    width={12}>
                    <label
                      id="CardDoctorFeeReportUX-label-139"
                      style={{minWidth: "max-content",fontSize: "0.85rem"}}>
                      จำนวนรวม(qty)
                    </label>
                    <Label
                      id="CardDoctorFeeReportUX-Label-140"
                      size="large"
                      style={{width: "100%", textAlign: "right"}}>
                      {props.summary?.raw_total_quantity ?? "\u00a0"}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-125"
                    inline={true}
                    style={{display: props.activeTab === "description"? "": "none"}}
                    width={12}>
                    <label
                      id="CardDoctorFeeReportUX-label-128"
                      style={{minWidth: "max-content",fontSize: "0.85rem"}}>
                      ยอดรวมผู้ป่วยจ่าย
                    </label>
                    <Label
                      id="CardDoctorFeeReportUX-Label-133"
                      size="large"
                      style={{width: "100%", textAlign: "right"}}>
                      {props.summary?.total_payable|| "\u00a0"}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-126"
                    inline={true}
                    width={12}>
                    <label
                      id="CardDoctorFeeReportUX-label-129"
                      style={{minWidth: "7.5rem", maxWidth: "7.5rem",fontSize: "0.85rem"}}>
                      ค่าบริการผู้ป่วยนอก
                    </label>
                    <Label
                      id="CardDoctorFeeReportUX-Label-132"
                      size="large"
                      style={{width: "100%", textAlign: "right"}}>
                      {props.summary?.total_revenue_outpatient|| "\u00a0"}
                    </Label>
                  </FormField>
                </FormGroup>
              </div>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-92"
              inline={true}
              width={8}>
              <div
                className="ui form"
                id="CardDoctorFeeReportUX-div-96"
                style={{width: "100%"}}>
                
                <FormGroup
                  id="CardDoctorFeeReportUX-FormGroup-99"
                  inline={true}
                  widths={16}>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-103"
                    inline={true}
                    width={9}>
                    <label
                      id="CardDoctorFeeReportUX-label-110"
                      style={{minWidth: "12rem", maxWidth: "12rem",fontSize: "0.85rem"}}>
                      รายรับจากการรักษา (รับเป็นเงิน)
                    </label>
                    <Label
                      id="CardDoctorFeeReportUX-Label-113"
                      size="large"
                      style={{width: "100%", textAlign: "right"}}>
                      {props.summary?.total_revenue_credit|| "\u00a0"}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-104"
                    inline={true}
                    width={8}>
                    <label
                      id="CardDoctorFeeReportUX-label-109"
                      style={{minWidth: "9.5rem", maxWidth: "9.5rem",fontSize: "0.85rem"}}>
                      รายรับที่แบ่ง (รับเป็นเงิน)
                    </label>
                    <Label
                      id="CardDoctorFeeReportUX-Label-114"
                      size="large"
                      style={{width: "100%", textAlign: "right"}}>
                      {props.summary?.final_revenue_credit|| "\u00a0"}
                    </Label>
                  </FormField>
                </FormGroup>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDoctorFeeReportUX-FormGroup-88"
            inline={true}
            style={{marginBottom: "-0.25rem"}}>
            <FormField
              id="CardDoctorFeeReportUX-FormField-93"
              inline={true}
              width={9}>
              <div
                className="ui form"
                id="CardDoctorFeeReportUX-div-118"
                style={{width: "100%"}}>
                
                <FormGroup
                  id="CardDoctorFeeReportUX-FormGroup-120"
                  inline={true}
                  widths={16}>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-121"
                    inline={true}
                    width={12}>
                  </FormField>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-122"
                    inline={true}
                    style={{display: props.activeTab === "description"? "": "none"}}
                    width={12}>
                  </FormField>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-123"
                    inline={true}
                    width={12}>
                    <label
                      id="CardDoctorFeeReportUX-label-130"
                      style={{minWidth: "7.5rem", maxWidth: "7.5rem",fontSize: "0.85rem"}}>
                      รายรับที่ไม่แบ่ง
                    </label>
                    <Label
                      id="CardDoctorFeeReportUX-Label-131"
                      size="large"
                      style={{width: "100%", textAlign: "right"}}>
                      {props.summary?.total_compensation_price|| "\u00a0"}
                    </Label>
                  </FormField>
                </FormGroup>
              </div>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-94"
              inline={true}
              width={8}>
              <div
                className="ui form"
                id="CardDoctorFeeReportUX-div-95"
                style={{width: "100%"}}>
                
                <FormGroup
                  id="CardDoctorFeeReportUX-FormGroup-98"
                  inline={true}>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-105"
                    inline={true}
                    width={9}>
                    <label
                      id="CardDoctorFeeReportUX-label-107"
                      style={{minWidth: "12rem", maxWidth: "12rem",fontSize: "0.85rem"}}>
                      รายรับจากโครงการ (แต้มสะสม)
                    </label>
                    <Label
                      id="CardDoctorFeeReportUX-Label-115"
                      size="large"
                      style={{width: "100%", textAlign: "right"}}>
                      {props.summary?.total_revenue_point|| "\u00a0"}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardDoctorFeeReportUX-FormField-106"
                    inline={true}
                    width={8}>
                    <label
                      id="CardDoctorFeeReportUX-label-108"
                      style={{minWidth: "9.5rem", maxWidth: "9.5rem",fontSize: "0.85rem"}}>
                      รายรับที่แบ่ง (แต้มสะสม)
                    </label>
                    <Label
                      id="CardDoctorFeeReportUX-Label-116"
                      size="large"
                      style={{width: "100%", textAlign: "right"}}>
                      {props.summary?.final_revenue_point|| "\u00a0"}
                    </Label>
                  </FormField>
                </FormGroup>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          className="ui form"
          id="CardDoctorFeeReportUX-div-141"
          style={{display: props.activeTab === "overview"? "": "none", marginTop: "0rem"}}>
          
          <FormGroup
            id="CardDoctorFeeReportUX-FormGroup-142"
            inline={true}
            style={{marginBottom: "0.25rem"}}>
            <FormField
              id="CardDoctorFeeReportUX-FormField-144"
              inline={true}
              width={4}>
              <label
                id="CardDoctorFeeReportUX-label-152"
                style={{minWidth: "max-content", fontSize: "0.85rem"}}>
                ยอดรวมต้นสังกัด / ผู้ป่วยชำระแล้ว
              </label>
              <Label
                id="CardDoctorFeeReportUX-Label-158"
                size="large"
                style={{width: "100%", textAlign: "right"}}>
                {props.summary?.total_paid_price|| "\u00a0"}
              </Label>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-145"
              inline={true}
              width={4}>
              <label
                id="CardDoctorFeeReportUX-label-153"
                style={{minWidth: "8.5rem", maxWidth: "8.5rem",fontSize: "0.85rem"}}>
                ยอดรวมรอเบิกต้นสังกัดและ ผู้ป่วยค้างชำระ
              </label>
              <Label
                id="CardDoctorFeeReportUX-Label-159"
                size="large"
                style={{width: "100%", textAlign: "right"}}>
                {props.summary?.total_waiting_claim_price|| "\u00a0"}
              </Label>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-146"
              inline={true}
              width={4}>
              <label
                id="CardDoctorFeeReportUX-label-154"
                style={{minWidth: "8.5rem", maxWidth: "8.5rem",fontSize: "0.85rem"}}>
                ยอดค่า Lab (หักแพทย์ (รับเป็นเงิน))
              </label>
              <Label
                id="CardDoctorFeeReportUX-Label-160"
                size="large"
                style={{width: "100%", textAlign: "right"}}>
                {props.summary?.total_lab_df_deduct_credit|| "\u00a0"}
              </Label>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-147"
              inline={true}
              width={4}>
              <label
                id="CardDoctorFeeReportUX-label-155"
                style={{minWidth: "max-content", fontSize: "0.85rem"}}>
                ยอดค่า Lab (ไม่หักแพทย์ (รับเป็นเงิน))
              </label>
              <Label
                id="CardDoctorFeeReportUX-Label-161"
                size="large"
                style={{width: "100%", textAlign: "right"}}>
                {props.summary?.total_lab_price_credit|| "\u00a0"}
              </Label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDoctorFeeReportUX-FormGroup-143"
            inline={true}
            style={{marginBottom: "0.25rem"}}>
            <FormField
              id="CardDoctorFeeReportUX-FormField-148"
              inline={true}
              width={4}>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-149"
              inline={true}
              width={4}>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-150"
              inline={true}
              width={4}>
              <label
                id="CardDoctorFeeReportUX-label-157"
                style={{minWidth: "8.5rem", maxWidth: "8.5rem",fontSize: "0.85rem"}}>
                ยอดค่า Lab (หักแพทย์ (แต้มสะสม)) 
              </label>
              <Label
                id="CardDoctorFeeReportUX-Label-163"
                size="large"
                style={{width: "100%", textAlign: "right"}}>
                {props.summary?.total_lab_df_deduct_point|| "\u00a0"}
              </Label>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-151"
              inline={true}
              width={4}>
              <label
                id="CardDoctorFeeReportUX-label-164"
                style={{minWidth: "max-content", fontSize: "0.85rem"}}>
                ยอดค่า Lab (ไม่หักแพทย์ (แต้มสะสม)) 
              </label>
              <Label
                id="CardDoctorFeeReportUX-Label-165"
                size="large"
                style={{width: "100%", textAlign: "right"}}>
                {props.summary?.total_lab_price_point|| "\u00a0"}
              </Label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDoctorFeeReportUX-FormGroup-166"
            inline={true}
            style={{marginBottom: "0.25rem"}}>
            <FormField
              id="CardDoctorFeeReportUX-FormField-167"
              inline={true}
              width={4}>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-168"
              inline={true}
              width={4}>
              <label
                id="CardDoctorFeeReportUX-label-171"
                style={{minWidth: "8.5rem", maxWidth: "8.5rem",fontSize: "0.85rem"}}>
                ยอดรวมรอเบิก (สะสม)
              </label>
              <Label
                id="CardDoctorFeeReportUX-Label-174"
                size="large"
                style={{width: "100%", textAlign: "right"}}>
                {props.summary?.total_waiting_claim_price_cumulative|| "\u00a0"}
              </Label>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-169"
              inline={true}
              width={4}>
              <label
                id="CardDoctorFeeReportUX-label-172"
                style={{minWidth: "8.5rem", maxWidth: "8.5rem",fontSize: "0.85rem"}}>
                ยอดรวมแต้ม (สะสม)
              </label>
              <Label
                id="CardDoctorFeeReportUX-Label-173"
                size="large"
                style={{width: "100%", textAlign: "right"}}>
                {props.summary?.total_point|| "\u00a0"}
              </Label>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-170"
              inline={true}
              width={4}>
            </FormField>
          </FormGroup>
        </div>
        <Form
          id="CardDoctorFeeReportUX-Form-27">
          <FormGroup
            id="CardDoctorFeeReportUX-FormGroup-28"
            inline={true}
            style={{marginTop: "0rem"}}>
            <FormField
              id="CardDoctorFeeReportUX-FormField-29"
              style={{flex:1}}>
            </FormField>
            <FormField
              id="CardDoctorFeeReportUX-FormField-30"
              style={{display: "flex"}}>
              <div
                id="CardDoctorFeeReportUX-div-31">
                {props.buttonPrint}
              </div>
            </FormField>
          </FormGroup>
        </Form>
      </div>
    )
}

CardDoctorFeeReportUX.displayName = "CardDoctorFeeReportUX";
export default React.memo(CardDoctorFeeReportUX)

export const screenPropsDefault = {}

/* Date Time : Thu May 22 2025 11:17:11 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-1"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0.5rem\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.table?.title || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.15rem\", fontWeight: \"bold\", padding: \"2.5px 0\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", marginBottom: \"0.75rem\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดค่าตอบแทน"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"description\"? \"blue\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Button-6"
        },
        "name": {
          "type": "value",
          "value": "description"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.75rem\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาพรวมค่าตอบแทนแพทย์"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"overview\"? \"blue\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Button-7"
        },
        "name": {
          "type": "value",
          "value": "overview"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.75rem\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-23"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 24,
      "name": "Table",
      "parent": 23,
      "props": {
        "data": {
          "type": "code",
          "value": "props.data"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.onGetTdProps"
        },
        "getTheadThProps": {
          "type": "code",
          "value": "props.onGetTheadThProps"
        },
        "headers": {
          "type": "code",
          "value": "props.table?.headers"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Table-24"
        },
        "keys": {
          "type": "code",
          "value": "props.table?.keys"
        },
        "minRows": {
          "type": "code",
          "value": "6"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: props.table?.height || \"\"}"
        },
        "widths": {
          "type": "code",
          "value": "props.table?.widths"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Form-27"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormGroup",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0rem\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-29"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-30"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-31"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form small"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-56"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormGroup",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 57,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-58"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"10rem\"}"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-61"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"10rem\"}"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-62"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-63"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-64"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.activeTab === \"description\"? \"\": \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รักษา"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-66"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "label",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-67"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": "คลินิกที่ออกตรวจ"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-68"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "คาบ"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "label",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาออกตรวจ"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-70"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการชำระเงินของผู้ป่วย"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-71"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 74,
      "name": "DateTextBox",
      "parent": 72,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-DateTextBox-74"
        },
        "onChange": {
          "type": "code",
          "value": "(value: string)=>props.onChangeFilter?.(null,{name:\"startDate\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.startDate || \"\""
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 75,
      "name": "DateTextBox",
      "parent": 73,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-DateTextBox-75"
        },
        "onChange": {
          "type": "code",
          "value": "(value: string)=>props.onChangeFilter?.(null,{name:\"endDate\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.endDate || \"\""
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "Dropdown",
      "parent": 62,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Dropdown-76"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions|| []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.division || \"\""
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "Dropdown",
      "parent": 63,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Dropdown-77"
        },
        "name": {
          "type": "value",
          "value": "period"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.periodOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.period || \"\""
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Dropdown",
      "parent": 64,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Dropdown-78"
        },
        "name": {
          "type": "value",
          "value": "workingType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.workingTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.workingType|| \"\""
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "Dropdown",
      "parent": 65,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Dropdown-79"
        },
        "name": {
          "type": "value",
          "value": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.paymentStatusOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.status|| \"\""
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-80"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-81"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{margin:  \"1rem 0 -1rem 0.5rem\",display: props.activeTab === \"description\"? \"\": \"none\", fontSize: \"0.85rem\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ ส่วนแบ่ง (%) ยังไม่ได้ถูกหักค่า LAB (ถ้ามี)"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-83"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": "C- ได้รับเป็นเงิน P-ได้รับเป็นแต้มสะสม"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-84"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"5rem\", marginTop: \"0.5rem\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "FormGroup",
      "parent": 85,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-86"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"-0.25rem\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormGroup",
      "parent": 85,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-87"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"-0.25rem\"}"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "FormGroup",
      "parent": 85,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-88"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"-0.25rem\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "FormField",
      "parent": 86,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-89"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "FormField",
      "parent": 86,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-90"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-91"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-92"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormField",
      "parent": 88,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-93"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "FormField",
      "parent": 88,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-94"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormGroup",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-98"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormGroup",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-99"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormGroup",
      "parent": 97,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-100"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-101"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-102"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormField",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-103"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "FormField",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-104"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormField",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-105"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "FormField",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-106"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "รายรับจากโครงการ (แต้มสะสม)"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-107"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"12rem\", maxWidth: \"12rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "label",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": "รายรับที่แบ่ง (แต้มสะสม)"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-108"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"9.5rem\", maxWidth: \"9.5rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": "รายรับที่แบ่ง (รับเป็นเงิน)"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-109"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"9.5rem\", maxWidth: \"9.5rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "รายรับจากการรักษา (รับเป็นเงิน)"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-110"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"12rem\", maxWidth: \"12rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "label",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "รายรับทั้งหมด"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-111"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"12rem\", maxWidth: \"12rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Label",
      "parent": 101,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_revenue_price || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-112"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Label",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_revenue_credit|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-113"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "Label",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.final_revenue_credit|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-114"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Label",
      "parent": 105,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_revenue_point|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-115"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "Label",
      "parent": 106,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.final_revenue_point|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-116"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-117"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-118"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "FormGroup",
      "parent": 117,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-119"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "FormGroup",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-120"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "FormField",
      "parent": 120,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-121"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "FormField",
      "parent": 120,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-122"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.activeTab === \"description\"? \"\": \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "FormField",
      "parent": 120,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-123"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "FormField",
      "parent": 119,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-124"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.activeTab === \"description\"? \"\": \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "FormField",
      "parent": 119,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-125"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.activeTab === \"description\"? \"\": \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "FormField",
      "parent": 119,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-126"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "label",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดรวมส่งเบิก"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-127"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "label",
      "parent": 125,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดรวมผู้ป่วยจ่าย"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-128"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "label",
      "parent": 126,
      "props": {
        "children": {
          "type": "value",
          "value": "ค่าบริการผู้ป่วยนอก"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-129"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"7.5rem\", maxWidth: \"7.5rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "label",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": "รายรับที่ไม่แบ่ง"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-130"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"7.5rem\", maxWidth: \"7.5rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "Label",
      "parent": 123,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_compensation_price|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-131"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "Label",
      "parent": 126,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_revenue_outpatient|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-132"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "Label",
      "parent": 125,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_payable|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-133"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "Label",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_send_claim|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-134"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-135"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.activeTab === \"overview\"? \"\": \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "label",
      "parent": 135,
      "props": {
        "children": {
          "type": "value",
          "value": "สถาะส่งเบิก"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-136"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "Dropdown",
      "parent": 135,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Dropdown-137"
        },
        "name": {
          "type": "value",
          "value": "filter.status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.sentClaimStatusOptions||[]"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.status|| \"\""
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "FormField",
      "parent": 119,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-138"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.activeTab === \"overview\"? \"\": \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "label",
      "parent": 138,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนรวม(qty)"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-139"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "Label",
      "parent": 138,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.raw_total_quantity ?? \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-140"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-div-141"
        },
        "style": {
          "type": "code",
          "value": "{display: props.activeTab === \"overview\"? \"\": \"none\", marginTop: \"0rem\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormGroup",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-142"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.25rem\"}"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "FormGroup",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-143"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.25rem\"}"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-144"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-145"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-146"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 147,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-147"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "FormField",
      "parent": 143,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-148"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "FormField",
      "parent": 143,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-149"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "FormField",
      "parent": 143,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-150"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "FormField",
      "parent": 143,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-151"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "label",
      "parent": 144,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดรวมต้นสังกัด / ผู้ป่วยชำระแล้ว"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-152"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontSize: \"0.85rem\"}"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "label",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดรวมรอเบิกต้นสังกัดและ ผู้ป่วยค้างชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-153"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"8.5rem\", maxWidth: \"8.5rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "label",
      "parent": 146,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดค่า Lab (หักแพทย์ (รับเป็นเงิน))"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-154"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"8.5rem\", maxWidth: \"8.5rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "label",
      "parent": 147,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดค่า Lab (ไม่หักแพทย์ (รับเป็นเงิน))"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-155"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontSize: \"0.85rem\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 157,
      "name": "label",
      "parent": 150,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดค่า Lab (หักแพทย์ (แต้มสะสม)) "
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-157"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"8.5rem\", maxWidth: \"8.5rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "Label",
      "parent": 144,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_paid_price|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-158"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "Label",
      "parent": 145,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_waiting_claim_price|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-159"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "Label",
      "parent": 146,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_lab_df_deduct_credit|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-160"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 161,
      "name": "Label",
      "parent": 147,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_lab_price_credit|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-161"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 163,
      "name": "Label",
      "parent": 150,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_lab_df_deduct_point|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-163"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "label",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดค่า Lab (ไม่หักแพทย์ (แต้มสะสม)) "
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-164"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontSize: \"0.85rem\"}"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "Label",
      "parent": 151,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_lab_price_point|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-165"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "FormGroup",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormGroup-166"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.25rem\"}"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-167"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-168"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 169,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-169"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-FormField-170"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "label",
      "parent": 168,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดรวมรอเบิก (สะสม)"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-171"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"8.5rem\", maxWidth: \"8.5rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "label",
      "parent": 169,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดรวมแต้ม (สะสม)"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-label-172"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"8.5rem\", maxWidth: \"8.5rem\",fontSize: \"0.85rem\"}"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "Label",
      "parent": 169,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_point|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-173"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "Label",
      "parent": 168,
      "props": {
        "children": {
          "type": "code",
          "value": "props.summary?.total_waiting_claim_price_cumulative|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Label-174"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"right\"}"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานค่าตอบแทนแพทย์ตามวันที่รับชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardDoctorFeeReportUX-Button-175"
        },
        "name": {
          "type": "value",
          "value": "doctorFeeByPaymentReport"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานค่าตอบแทนแพทย์ตามวันที่รับชำระ\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.75rem\"}"
        }
      },
      "seq": 175,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": true,
  "memo": true,
  "name": "CardDoctorFeeReportUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 100
}

*********************************************************************************** */
